import { useRouter } from "next/router";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/imports/[importType]/[id]/import_log_errors/Page";
import type { ImportType } from "~/models/ImportLog";

export const PATH = (importType: ImportType, importLogId: number): string =>
	`/settings/imports/${importType}/${importLogId}/import_log_errors`;

function Home() {
	const router = useRouter();
	const { importType, id: importLogId } = router.query;

	if (typeof importType !== "string" || typeof importLogId !== "string") {
		return null;
	}

	return (
		<>
			<NskHead title="過去データ取込エラーログ" />
			<Component importLogId={Number(importLogId)} importType={importType} />
		</>
	);
}

export default Home;
